import * as Yup from 'yup';

export default Yup.object().shape({
  instagram: Yup.string().matches(
    /^[\w](?!.*?\.{2})[\w.]{1,28}[\w]$/,
    'SCHEMA_ERRORS.INSTAGRAM_FORMAT_INVALID'
  ),
  webSite: Yup.string().url('SCHEMA_ERRORS.WEB_SITE_URL_INVALID')
});
